import React from 'react';
import classNames from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';

export type PillVariant = 'neutral' | 'muted' | 'success' | 'danger' | 'primary' | 'primaryTint';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    height: 24,
    padding: '0 8px',
    borderRadius: 16,
    fontSize: 13,
    fontWeight: 'bold',
    lineHeight: 1,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
  },

  small: {
    height: 20,
    fontSize: 11,
  },

  neutral: {
    backgroundColor: '#EEEFF4',
    color: '#4F5467',
  },

  muted: {
    backgroundColor: '#F5F6F9',
    color: '#B4B7C9',
  },

  success: {
    backgroundColor: '#DFFFE6',
    color: '#087A21',
  },

  danger: {
    backgroundColor: '#FDE8E6',
    color: '#A3261E',
  },

  primary: {
    backgroundColor: theme.palette.primary.main,
    color: '#FFFFFF',
  },

  primaryTint: {
    backgroundColor: 'rgba(99, 84, 245, 0.12)',
    color: theme.palette.primary.main,
  },
}));

interface Props {
  variant?: PillVariant;
  small?: boolean;
  className?: string;
  children: React.ReactNode;
}

const Pill = ({ variant = 'neutral', small = false, className, children }: Props) => {
  const classes = useStyles();

  return (
    <span className={classNames(classes.root, classes[variant], small && classes.small, className)}>
      {children}
    </span>
  );
};

export default Pill;
